export default [{
    path: 'equipment',
    component: () => import('@/views/dcim/equipment/equipment-index'),
}]
